import webBiLogger from '@wix/web-bi-logger';
import initSchemaLoggerDevCenter from '@wix/bi-logger-developer-center';
import initSchemaLoggerWixDocs from '@wix/bi-logger-wixpress-wix-public-docs-viewer';
import {
  fromRelativeUrlToAbsoluteUrl,
  getArticleNameAndCategoryFromArticleLink,
  getPathnameFromUrl,
  isAbsoluteUrl,
  isLinkToOutsideTheViewer,
} from '../../../../utils/locationUtils';
import window from 'global';
import { transformNodeKeyToDocsUrl } from '../../../../utils/flattenTree/utils';
import { LOGGER_TYPES } from '../../loggerTypes';

const options = {};
const schemaLoggerDevCenter = initSchemaLoggerDevCenter(webBiLogger)(options);
const schemaLoggerWixDocs = initSchemaLoggerWixDocs(webBiLogger)(options);

export const openTokenModalClick = ({ isTokenExist, origin }) =>
  schemaLoggerDevCenter.devCenterOpenTokenModalClick({ isTokenExist, origin });

export const searchResultsAction = (
  {
    chosen_article_url,
    chosen_article_name,
    chosen_article_category,
    first_article_category,
    first_article_name,
    first_article_url,
    num_of_results,
    search_term,
    user_action,
  },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsSearchResults({
    chosen_article_url,
    chosen_article_name,
    chosen_article_category,
    customer_id,
    first_article_name,
    first_article_category,
    first_article_url,
    num_of_results,
    search_term,
    user_action,
  });

export const examplesCopyCodeClick = (
  { article_url, article_name, id, category_name },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsCopyCode({
    article_url,
    article_name,
    category_name,
    id,
    customer_id,
  });

export const examplesOpenClose = (
  { action, articleUrl, articleName, exampleId, categoryName },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsOpenCloseExamples({
    action,
    articleName,
    articleUrl,
    categoryName,
    customer_id,
    exampleId,
  });

export const contactOwnerLickClicked = (
  { article_name, article_url, link_type },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsContactOwnerLinkClicked({
    article_name,
    article_url,
    customer_id,
    link_type,
  });

export const wixDocsSiteVisit = (
  { page_url, article_name, category_name },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsSiteVisit({
    page_url,
    article_name,
    category_name,
    customer_id,
    referral_url: document.referrer || '',
  });

export const wixDocsObjectShowMembersClick = (
  { article_name, article_url, category_name, action },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsObjectShowMembersClick({
    article_url,
    article_name,
    category_name,
    customer_id,
    action,
  });

export const wixDocsNavigationClick = (
  { nav_type, category_name, article_name, article_url },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsNavigationClick({
    nav_type,
    category_name,
    article_name,
    article_url,
    customer_id,
  });

export const wixDocsViewSourceClick = (
  { article_name, article_url },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsViewSourceClick({
    article_name,
    article_url,
    customer_id,
  });

export const relatedSiteClick = (
  { selected_name, selected_url },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsRelatedSiteClick({
    selected_name,
    selected_url,
    customer_id,
  });

export const wixDocsTryItOutClick = (
  { article_name, article_url, category_name },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsTryItOutClick({
    article_name,
    article_url,
    category_name,
    customer_id,
  });

export const wixDocsShareableLinkClick = (
  { article_name, article_url, category_name },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsShareableLinkClick({
    article_name,
    article_url,
    category_name,
    customer_id,
  });

export const wixDocsSendRequestClient = (
  {
    article_name,
    article_url,
    body,
    category_name,
    http_method,
    invoked_url,
    is_test_token_used,
  },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsSendRequestClient({
    article_name,
    article_url,
    body,
    category_name,
    http_method,
    invoked_url,
    is_test_token_used,
    customer_id,
  });

export const wixDocsGiveFeedbackClick = (
  { article_name, article_url, positive_feedback },
  customer_id,
) =>
  schemaLoggerWixDocs.wixDocsGiveFeedbackClick({
    article_name,
    article_url,
    positive_feedback,
    customer_id,
  });

export const wixDocsVisitLocalViewer = (localViewerId, customer_id) =>
  schemaLoggerWixDocs.wixDocsVisitLocalViewer({
    customer_id,
    local_viewer_id: localViewerId,
  });

export const logNavigationClickFromLink = (logger, link, store, navType) => {
  const host = window.location.host;
  if (link && !isLinkToOutsideTheViewer(link, host, store.storePath)) {
    const linkPathname = isAbsoluteUrl(link) ? getPathnameFromUrl(link) : link;
    const {
      categoryName,
      articleName,
    } = getArticleNameAndCategoryFromArticleLink(linkPathname);
    const relativeUrl = `/${categoryName}${
      articleName ? `/${transformNodeKeyToDocsUrl(articleName)}` : ''
    }`;
    const articleUrl = fromRelativeUrlToAbsoluteUrl(
      relativeUrl,
      window.location.origin,
      store,
    );
    logger.getLogger(LOGGER_TYPES.ANALYTICS_BI).log(wixDocsNavigationClick, {
      article_name: articleName,
      article_url: articleUrl,
      category_name: categoryName,
      nav_type: navType,
    });
  }
};
